<template>
    <v-container fluid class="mx-0 px-3">
        <v-card flat class="avsb-card-background">
            <v-card-title class="pl-1 py-2">Tasks</v-card-title>
        </v-card>

        <!-- Tables -->
        <TableTasks />

        <!-- Dialogs -->
        <DialogTaskCreate />
    </v-container>
</template>

<script>
export default {
    components: {
        DialogTaskCreate: () =>
            import("@/components/admin/dialogs/dialogTaskCreate"),
        TableTasks: () => import("@/components/admin/tables/tableTasks"),
    },
    methods: {},
    name: "Tasks",
    // Lifecycle hooks.
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
};
</script>
